import main from '@/constant';

import {
  MODULES
} from "@constants"

/**
 * Used on vuex namespaced store
 */
export const MODULE = MODULES.MISSION_DETAILS;

export const MISSION_ROUTES = [
  'missionDetail',
  'donationMissionDetail'
];

export const TYPES = {
  TIME: main.MISSION_TYPE_TIME,
  GOAL: main.MISSION_TYPE_GOAL,
  DONATION: main.MISSION_TYPE_DONATION
};

export const SHIFT_TYPES = {
  ONCE: main.ONE_TIME,
  FLEXI: main.FLEXIBLE,
  MULTI: main.MULTI_DATE,
  SHIFT: main.SHIFT
};

export const APPLY_TYPES = {
  DISCOVER_TEAM: 'discover_team',
  APPLY_OPTION: 'apply_option'
};

export const PRE_SCREENING_TYPES = {
  TEAM: main.TEAM,
  PRE_MISSION: main.PRE_MISSION,
  POST_MISSION: main.POST_MISSION,
  SHIFT: main.SHIFT
};

export const SETTINGS = {
  DONATION_RATING: main.DONATION_MISSION_RATINGS,
  VOLUNTEERING_RATING: main.MISSION_RATINGS,
  THEME: main.THEMES_ENABLED,
  MATCHING_GIFT: main.MATCHING_GIFT_SETTING,
  INVITE: main.INVITE_COLLEAGUE,
  REMINDER: main.MISSION_REMINDER,
  TWITTER: main.SHARE_MISSION_TWITTER,
  FACEBOOK: main.SHARE_MISSION_FACEBOOK,
  SKILL: main.SKILLS_ENABLED,
  RECENT_VOLUNTEERES: main.RECENT_VOLUNTEERES,
  TEST_MODE: main.DONATION_TEST_MODE,
  RELATED: main.RELATED_MISSIONS,
  TEAM: main.TEAM_VOLUNTEERING,
  QUESTIONNAIRE: main.SETTING_QUESTIONNAIRE
};

export const ACCESS = {
  RESTRICTED: 'RESTRICTED'
};

export const APPLICATION_STATUS = {
  APPROVED: 'AUTOMATICALLY_APPROVED',
  PENDING: 'PENDING',
  WAIT_LIST: 'WAIT_LIST',
};